import React, { useRef } from "react";
import "./ImageSlider.css";

export default function ImageSlider({
  label,
  items,
  selectedId,
  onSelect,
  loading = false,
  emptyText = "Sin imagenes",
}) {
  const trackRef = useRef(null);

  const scroll = (dir) => {
    if (!trackRef.current) return;
    trackRef.current.scrollBy({ left: dir * 240, behavior: "smooth" });
  };

  return (
    <div className="image-slider">
      <div className="image-slider-header">
        <span className="image-slider-label">{label}</span>
        {!loading && items.length > 0 && (
          <div className="image-slider-controls">
            <button type="button" onClick={() => scroll(-1)} aria-label="Anterior">&#9664;</button>
            <button type="button" onClick={() => scroll(1)} aria-label="Siguiente">&#9654;</button>
          </div>
        )}
      </div>

      <div className="image-slider-track" ref={trackRef}>
        {loading ? (
          <div className="image-slider-loading">Cargando referencias...</div>
        ) : items.length === 0 ? (
          <div className="image-slider-empty">{emptyText}</div>
        ) : (
          items.map((item) => (
            <button
              type="button"
              key={item.id}
              className={`image-slider-thumb ${selectedId === item.id ? "selected" : ""}`}
              onClick={() => onSelect(item.id === selectedId ? null : item.id)}
              title={item.description || item.filename}
            >
              <img src={item.url} alt={item.filename} loading="lazy" />
              <span className="image-slider-thumb-name">{item.filename}</span>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
